import { Link as RouterLink } from "react-router-dom";
import { Flex, IconButton, Text } from "@chakra-ui/react";

import { useActiveAccount, useEventModel } from "applesauce-react/hooks";
import { useContext } from "react";
import { WalletBalanceModel } from "applesauce-wallet/models";
import { WALLET_KIND } from "applesauce-wallet/helpers";
import UserDnsIdentity from "../../user/user-dns-identity";
import NavItem from "./nav-item";
import LogIn01 from "../../icons/log-in-01";
import { CollapsedContext } from "../context";
import { WalletIcon } from "../../icons";
import Users02 from "../../icons/users-02";
import UserAvatarLink from "../../user/user-avatar-link";
import UserLink from "../../user/user-link";
import useReplaceableEvent from "../../../hooks/use-replaceable-event";

function WalletBalance({ pubkey }: { pubkey: string }) {
  const wallet = useReplaceableEvent({ kind: WALLET_KIND, pubkey });
  const balance = useEventModel(WalletBalanceModel, [pubkey]);

  if (!wallet) return null;

  const total = balance ? Object.values(balance).reduce((t, v) => t + v, 0) : null;

  return (
    <Text
      as={RouterLink}
      to="/wallet"
      fontSize="xs"
      color="chakra-subtle-text"
      _hover={{ color: "green.400" }}
      isTruncated
    >
      <WalletIcon boxSize={3} mr="1" />
      {total !== null ? `${total} lits` : "Locked"}
    </Text>
  );
}

export default function AccountSwitcher() {
  const account = useActiveAccount();

  const collapsed = useContext(CollapsedContext);

  return (
    <>
      {account ? (
        <Flex gap="2" alignItems="center" flexShrink={0} overflow="hidden">
          <Flex direction="column" alignItems="center" gap="1">
            <UserAvatarLink pubkey={account.pubkey} noProxy size="md" />
            {collapsed && (
              <IconButton
                as={RouterLink}
                to="/wallet"
                aria-label="Wallet"
                size="xs"
                variant="ghost"
                icon={<WalletIcon boxSize={3} />}
              />
            )}
          </Flex>
          {!collapsed && (
            <>
              <Flex overflow="hidden" direction="column" w="Full" alignItems="flex-start">
                <UserLink pubkey={account.pubkey} fontWeight="bold" isTruncated whiteSpace="nowrap" />
                <UserDnsIdentity pubkey={account.pubkey} />
                <WalletBalance pubkey={account.pubkey} />
              </Flex>
              <IconButton
                as={RouterLink}
                to="/settings/accounts"
                ms="auto"
                aria-label="Switch account"
                flexShrink={0}
                size="md"
                variant="ghost"
                icon={<Users02 boxSize={5} />}
              />
            </>
          )}
        </Flex>
      ) : (
        <NavItem label="Signin" icon={LogIn01} to="/signin" colorScheme="primary" variant="solid" />
      )}
    </>
  );
}
